export default "__VITE_ASSET__C0Ubv_oZ__"